import instoreManageCardsModal from './instoreAddNewCardModal';

export default instoreManageCardsModal;
